import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import Base64 from 'crypto-js/enc-base64';
import Hex from 'crypto-js/enc-hex';
import { Error404 } from 'views/shared';
import { AppContext } from 'contexts';
import { KEYS } from 'config/constants';
import { Pano } from './components';

interface Params {
  listingId: string;
  esoft_order_id?: string;
}

function Home() {
  const { listingId, esoft_order_id } = useParams<Params>();

  const appContext = useContext(AppContext);
  const {
    hasError,
    setListingId,
    getCurrentMarker,
    setCurrentMarker,
    doesEsoftOrderExist,
  } = appContext;
  const [panoInstance, setPanoInstance] = useState(null);

  const image = getCurrentMarker();

  function legacyDecrypting(text: string) {
    const is_encoded = /%/i.test(listingId);
    let decodedURI = text;
    if (is_encoded === true) {
      decodedURI = decodeURIComponent(text);
    }
    const decrypted = AES.decrypt(decodedURI, KEYS.CRYPTO_KEY).toString(Utf8);
    return decrypted;
  }

  function decrypt(text: string) {
    const reb64 = Hex.parse(text);
    const bytes = reb64.toString(Base64);
    const decrypted = AES.decrypt(bytes, KEYS.CRYPTO_KEY);
    const plain = decrypted.toString(Utf8);
    if (!plain) {
      return legacyDecrypting(text);
    }
    return plain;
  }

  async function setPanoviewData() {
    let listing_id = Number(listingId);
    let esoft_usage = false;
    if (!listing_id) {
      listing_id = Number(decrypt(listingId));
    }
    if (
      esoft_order_id &&
      (await doesEsoftOrderExist(Number(esoft_order_id), listing_id))
    ) {
      esoft_usage = true;
    }
    setCurrentMarker(0);
    setListingId(listing_id, esoft_usage);
    setPanoInstance({ p: null, v: null, rot_interval_id: null });
  }

  useEffect(() => {
    setPanoviewData();
  }, []);

  return (
    <div className='page'>
      {!hasError ? <Pano instance={panoInstance} image={image} /> : <Error404 />}
    </div>
  );
}

export default Home;
